<!-- Runmode:milestone用のコンポーネント -->
<template>
  <div class="item" :class="[styleType]" :style="{cursor: cursorType}"
       @click="clickItem(act.sounds[0])"
       @touchstart="onTouchStart()"
       @touchend="onTouchEnd()"
       @touchmove="onTouchEnd()">

    <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchInAct()"></button>

    <!-- スマホ表示の場合 -->
    <template v-if="isMobile()">
      <!-- 音声認識ON時の英文 -->
      <p v-if="sreUse === 'true'" v-show="showBasicText">
        <span v-html="basicText" />
      </p>
      <!-- 音声認識OFF時の英文 -->
      <div v-else v-show="showBasicText" class="select">
        <span v-html="isTileChallenge ? tileTextHtml : basicText" />
      </div>
    </template>

    <!-- PC表示の場合 -->
    <template v-else>
      <!-- 音声認識ON時の英文 -->
      <div v-if="sreUse === 'true'">
        <p v-show="showBasicText" :class="getMilestoneTextFontClassAct(basicText, $parent.productLanguage)">
          <span v-html="getPopupTextElem(basicText)" />
        </p>
      </div>
      <!-- 音声認識OFF時の英文 -->
      <div v-else>
        <div v-show="showBasicText" class="select" :class="getMilestoneTextFontClassAct(basicText, $parent.productLanguage)">
          <div v-if="isTileChallenge">
            <div class="tile">
              <span v-html="getPopupTextElem(tileTextHtml)" />
            </div>
          </div>
          <div v-else>
            <span v-html="getPopupTextElem(basicText)" />
          </div>
        </div>
      </div>
    </template>

    <div class="card">
      <!-- 正解/不正解画像(音声認識ONの場合は非表示) -->
      <div v-if="sreUse !== 'true'" :class="{correct: isCorrect, incorrect: isIncorrect}"></div>
      <div class="image"><img v-bind:src="act.image"></div>
      <button v-if="showVoiceIcon" class="icon-voice"></button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

const STYLE_TYPE_TYPE1 = "type1";
const STYLE_TYPE_ACTIVE_TYPE2 = "active-type2";
const STYLE_TYPE_ACTIVE_TYPE3 = "active-type3";

/**
 * 出題中actのstate
 */
// スライド中
const QUESTION_STATE_INIT = "init";
// 出題時の音声再生
const QUESTION_STATE_INIT_AUDUO = "initAudio";
// 出題中
const QUESTION_STATE_START = "start";
// 音声再生ボタンで再生中
const QUESTION_STATE_START_AUDIO = "startAudio";
// 一時停止
const QUESTION_STATE_PAUSE = "pause";
// 終了
const QUESTION_STATE_END = "end";
// 正解時の音声再生
const QUESTION_STATE_END_AUDIO = "endAudio";

export default {
  name: "MilestoneAct",
  props: {
    act: Object,
    productLanguage: String,
    scriptSystems: Object,
    presentActIndex: Number,
    currentConfuserIndex: Number,
    answerState: Number,
    showAnswer: Boolean,
    showPinchInBtn: Boolean,
    pathstepMode: String,
    questionState: String
  },
  computed: {
    ...mapGetters([
      "showAllAnswer"
    ]),
    /**
     * ピンチイン表示
     * @returns {default.computed.$store.getters.showPinchIn}
     */
    showPinchInAct: function() {
      return this.$store.getters.showPinchIn;
    }
  },
  mixins: [
    common,
    runmode
  ],
  data: function() {
    return {
      showBasicText: true,
      showVoiceIcon: true,
      basicText: "",
      tileTextHtml: "",
      styleType: "",
      cursorType: "",
      isTileChallenge: false,
      isCorrect: false,
      isIncorrect: false,
      confuserLength: 0,
      // 拡大表示フラグ
      isShowPinchIn: false,
      // タッチイベント長押しタイマー
      touchTimer: null,
      correctTileText: []
    };
  },
  methods: {
    /**
     * itemブロッククリック
     * @param string sound 音声パス
     * @returns
     */
    clickItem: function(sound) {
      if (this.isShowPinchIn) {
        // 拡大表示の場合は処理終了
        return;
      }
      // 音声再生
      this.childAudioPlay(sound);
    },
    /**
     * カード押下時、音声再生
     */
    childAudioPlay: function(sound) {
      this.log("MilestoneAct start childAudioPlay");

      // 音声再生ボタンが非表示の場合は、何もしない
      if (this.showVoiceIcon) {
        this.$emit("childAudioPlay", sound, this.act.index);
      }
    },
    /**
     * 空所表示用のHTMLを作成
     */
    createTileTextHtml: function() {
      this.log("MilestoneAct start createTileTextHtml");

      // 表示文字列取得
      var obj = this.getTextObj();
      if (obj.textObj.tileText.length == 0) {
        if (obj.pinyin) {
          // ピンイン付き
          this.tileTextHtml = this.getChineseTextWithPinyin(obj.textObj.basicText, obj.pinyin.basicText);
        } else if (obj.kana) {
          // ふりがな表示
          this.tileTextHtml = this.getJapaneseTextWithKana(obj.textObj.basicText, obj.textObj.superScripts, obj.textObj.confusers);
        } else {
          this.tileTextHtml = obj.textObj.basicText;
        }
        return;
      }

      var tmpText = "";
      var correctIndex = 0;
      var words = this.getDividedTexts(obj.textObj.tileText);
      for (var i = 0; i < words.length; i++) {
        if (words[i].match(/\[([^\]]*)\]/g)) {
          // 正解済みの場合は、spanをいれない
          var index = this.correctTileText[correctIndex];
          if (index != null) {
            var confusers = obj.textObj.confusers[index];
            var word = this.getCorrectWord(confusers);
            tmpText = tmpText.concat(word);
            correctIndex++;
          } else {
            tmpText = tmpText.concat('<span class="input"></span>');
          }

          this.confuserLength++;
        } else {
          tmpText = tmpText.concat(words[i]);
        }
      }

      if (obj.pinyin) {
        // 正解済みの場合は、正解の単語を使用する
        var text = obj.pinyin.tileText;
        for (var k = 0; k < this.correctTileText.length; k++) {
          var correctIndex = this.correctTileText[k];
          var confusers = obj.pinyin.confusers[correctIndex];
          var word = this.getCorrectWord(confusers);
          var match = "[" + correctIndex + "]";
          text = text.replace(match, word);
        }

        // ピンイン付き
        var pinyin = text.replace(/\[([^\]]*)\]/g, "").replace(/ +/g, " ");
        tmpText = this.getChineseTextWithPinyin(tmpText, pinyin);
      }

      if (obj.kana) {
        // ふりがな表示
        tmpText = this.getJapaneseTextWithKana(tmpText, obj.textObj.superScripts, obj.textObj.confusers);
      }

      this.tileTextHtml = tmpText;
    },
    /**
     * 正解の選択肢を取得
     */
    getCorrectWord: function(confusers) {
      var res = "";
      for (var i = 0; i < confusers.length; i++) {
        if (confusers[i].correct) {
          res = confusers[i].text;
          break;
        }
      }

      res = res.replace(/(,|\.|\?)/g, "");
      return res;
    },
    /**
     * 英文と音声再生ボタンの表示設定
     */
    initShow: function(createTile) {
      if (this.act.usage == -1) {
        this.showBasicText = false;
        this.showVoiceIcon = false;
        this.styleType = "";
        this.cursorType = constants.CURSOR_DEFAULT;
        return;
      }

      if (this.sreUse === "true") {
        this.showSpeech();
      } else {
        this.showTile(createTile);
      }
    },
    /**
     *
     */
    showSpeech: function() {
      if (this.act.usage == 1) {
        switch (this.act.textPolicy) {
          case "r":
            this.styleType = STYLE_TYPE_TYPE1;
            this.basicText = "";
            this.showVoiceIcon = false;
            this.cursorType = constants.CURSOR_DEFAULT;
            break;
          case "n":
            this.styleType = STYLE_TYPE_TYPE1;
            this.basicText = "";
            this.showVoiceIcon = true;
            this.cursorType = constants.CURSOR_POINTER;
            break;
          default:
            this.styleType = STYLE_TYPE_ACTIVE_TYPE2;
            this.showVoiceIcon = true;
            this.cursorType = constants.CURSOR_POINTER;
            break;
        }

        this.showBasicText = true;
      } else if (this.act.usage == 0) {
        this.styleType = STYLE_TYPE_ACTIVE_TYPE2;
        this.showBasicText = true;
        this.showVoiceIcon = true;
        this.cursorType = constants.CURSOR_POINTER;
      }
    },
    /**
     *
     */
    showTile: function(createTile) {
      if (this.act.usage == 1) {
        switch (this.act.textPolicy) {
          case "r":
            if (createTile) {
              this.createTileTextHtml();
            }
            this.styleType = STYLE_TYPE_ACTIVE_TYPE3;
            this.isTileChallenge = true;
            this.showVoiceIcon = false;
            this.cursorType = constants.CURSOR_DEFAULT;
            break;
          default:
            this.styleType = STYLE_TYPE_ACTIVE_TYPE3;
            this.isTileChallenge = false;
            this.showVoiceIcon = true;
            this.cursorType = constants.CURSOR_POINTER;
            break;
        }

        this.showBasicText = true;
      } else if (this.act.usage == 0) {
        this.styleType = STYLE_TYPE_ACTIVE_TYPE3;
        this.isTileChallenge = false;
        this.showBasicText = true;
        this.showVoiceIcon = true;
        this.cursorType = constants.CURSOR_POINTER;
      }
    },
    /**
     * 回答を表示
     */
    correctShow: function() {
      this.log("MilestoneAct start correctShow");

      if (this.act.usage == -1) {
        return;
      }

      // 英文の確認
      var obj = this.getTextObj();
      if (obj.pinyin) {
        // ピンイン付き
        this.basicText = this.getChineseTextWithPinyin(obj.textObj.basicText, obj.pinyin.basicText);
      } else if (obj.kana) {
        // ふりがな表示
        this.basicText = this.getJapaneseTextWithKana(obj.textObj.basicText, obj.textObj.superScripts);
      } else {
        this.basicText = obj.textObj.basicText;
      }

      if (this.sreUse === "true") {
        this.styleType = STYLE_TYPE_ACTIVE_TYPE2;
      } else {
        this.styleType = STYLE_TYPE_ACTIVE_TYPE3;
      }

      this.isTileChallenge = false;
      this.showVoiceIcon = true;
      this.showBasicText = true;
      this.cursorType = constants.CURSOR_POINTER;
    },
    /**
     * 表示テキスト情報取得
     * @returns {default.methods.getTextObj.ret}
     */
    getTextObj: function() {
      return this.getTextObjByScriptID(this.act.texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
    },
    /**
     * BasicText表示設定
     * @returns {undefined}
     */
    setBasicText: function() {
      var obj = this.getTextObj();
      var text = obj.textObj.basicText;
      if (obj.pinyin) {
        // ピンイン付き
        text = this.getChineseTextWithPinyin(text, obj.pinyin.basicText);
      }
      if (obj.kana) {
        // ふりがな表示
        text = this.getJapaneseTextWithKana(obj.textObj.basicText, obj.textObj.superScripts);
      }

      this.basicText = text;
    },
    /**
     * 選択肢表示テキスト一覧取得
     */
    createSelectAnswerTexts: function(confuserIndex) {
      // テキストオブジェクト取得
      var obj = this.getTextObj(this.act);
      var confusers = obj.textObj.confusers;
      var pinyin = obj.pinyin;
      var result = [];
      if (confusers.length != 0 && confusers[confuserIndex]) {
        for (let i = 0; i < confusers[confuserIndex].length; i++) {
          var text = confusers[confuserIndex][i].text;
          if (pinyin && pinyin.confusers[confuserIndex][i]) {
            // ピンイン表示
            text = this.getChineseTextWithPinyin(text, pinyin.confusers[confuserIndex][i].text);
          }
          if (obj.kana) {
            // ふりがな表示
            text = this.getJapaneseTextWithKana(text, confusers[confuserIndex][i].superScripts);
          }
          result[i] = { text: text, correct: confusers[confuserIndex][i].correct };
        }
      }

      return result;
    },
    clickPinchInAct: function() {
      this.log("MilestoneAct start clickPinchIn");

      switch (this.questionState) {
        case QUESTION_STATE_START:
        case QUESTION_STATE_START_AUDIO:
          break;
        case QUESTION_STATE_PAUSE:
          if (!this.showAllAnswer) {
            return;
          }
          break;
        default:
          return;
      }

      this.isShowPinchIn = true;

      // 拡大表示パラメータセット
      var pinchInActParams = {
        pinchInAct: this.act,
        pinchTileText: "",
        pinchInShowAnswerText: "",
        pinchInShowVoice: this.showVoiceIcon,
        pinchInShowTextAct: this.showBasicText,
        pinchInDispText: this.basicText,
        pinchInActIndex: this.act.index,
        pathstepMode: this.pathstepMode
      };

      // Tile系の表示テキスト
      if (this.isTileChallenge) {
        pinchInActParams.pinchTileText = {
          answerText: this.basicText,
          questionText: this.tileTextHtml
        };
      }

      this.$store.dispatch("showPinchIn", pinchInActParams);

      this.log("MilestoneAct clickPinchIn: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("MilestoneAct start recievePinchOut");

      this.isShowPinchIn = false;

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("MilestoneAct recievePinchOut: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * 長押しイベント開始
     */
    onTouchStart: function() {
      if (this.act.usage == -1) {
        return;
      }

      var self = this;
      this.touchTimer = setTimeout(function() {
        self.clickPinchInAct();
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    }
  },
  created: function() {
    this.log("MilestoneAct start created");

    this.setBasicText();

    // 英文と音声再生ボタンの表示設定
    this.initShow(true);
  },
  mounted: function() {
    this.log("MilestoneAct start mounted");
  },
  watch: {
    /**
     * 全解答表示を監視
     */
    showAllAnswer: function(newstatus) {
      // 出題中のact以外は何もしない
      if (this.act.index != this.presentActIndex) {
        return;
      }

      if (newstatus) {
        this.correctShow();
      } else {
        this.initShow(false);
      }
    },
    /**
     * 回答状態を監視
     */
    answerState: function(newstatus) {
      this.isCorrect = false;
      this.isIncorrect = false;

      // 出題中のact以外は何もしない
      if (this.act.index != this.presentActIndex) {
        return;
      }

      if (newstatus == 1) {
        if (this.confuserLength - 1 == this.currentConfuserIndex) {
          // 全選択肢回答
          this.isCorrect = true;
          this.correctShow();
        } else {
          this.correctTileText.push(this.currentConfuserIndex);

          var confuser = this.createSelectAnswerTexts(this.currentConfuserIndex);
          var word = this.getCorrectWord(confuser);
          this.tileTextHtml = this.tileTextHtml.replace('<span class="input"></span>', word);
        }
      } else if (newstatus == 0) {
        this.isIncorrect = true;
      }
    },
    showAnswer: function(newstatus) {
      if (!newstatus) {
        return;
      }

      // 出題中のact以外は何もしない
      if (this.act.index != this.presentActIndex) {
        return;
      }

      this.styleType = STYLE_TYPE_ACTIVE_TYPE2;
      this.setBasicText();
      this.showVoiceIcon = true;
      this.showBasicText = true;
      this.cursorType = constants.CURSOR_POINTER;
    },
    /**
     * 中国語表示切り替え
     *
     * @param {String} newstatus
     */
    scriptType: function(newstatus) {
      if (this.basicText.length != 0) {
        this.setBasicText();
      }

      this.createTileTextHtml();
    },
    /**
     * 表示切り替え
     *
     * @param {String} newstatus
     */
    displayMode: function(newstatus) {
      if (this.basicText.length != 0) {
        this.setBasicText();
      }

      this.createTileTextHtml();
    },
    /**
     * ピンチイン表示
     */
    showPinchInAct: function(newShowPinchIn) {
      if (!newShowPinchIn) {
        // 閉じる
        this.recievePinchOut();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/card";
</style>



// WEBPACK FOOTER //
// MilestoneAct.vue?7bc7530c